export const nameMask = (value: string | null | undefined) => {
  if(!value) return '';
  const valueTrimmed = value.trim();
  if (!valueTrimmed) return '';
  return valueTrimmed.replace(/\s+/g, ' ')
    .toLowerCase()
    .split(".")
    .map((txt) => (txt.length === 1 ? txt.toUpperCase() : txt))
    .join(".")
    .split(' ')
    .map(word => {
      if(['e', 'a', 'o', 'de', 'da', 'do', 'des', 'dos', 'das'].includes(word)) return word;
      return word.charAt(0).toUpperCase() + word.slice(1);
    }).join(' ');
};
